import { ClientType } from '../types';
import { useEffect, useState } from 'preact/hooks';
import { getClientType } from './common';
import { throttle } from 'lodash';

export const ScreenResolution = (): [clientType: ClientType, width: number] => {
  const [width, setWidth] = useState<number>(0);
  const [clientType, setClientType] = useState<ClientType>(null);

  useEffect(() => {
    setClientType(getClientType(window.innerWidth));

    const throttledHandleWindowSizeChange = throttle(() => {
      if (typeof window !== 'undefined') {
        setWidth(window?.innerWidth || 0);
        setClientType(getClientType(window?.innerWidth || 0));
      }
    }, 100);

    window.addEventListener('resize', throttledHandleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', throttledHandleWindowSizeChange);
    };
  }, []);

  return [clientType, width];
};
